
  import { Component, Vue } from 'vue-property-decorator';
  import PageFooter from '@/components/page-footer.vue';
	import PickerDate from '@/components/picker-date.vue';
  
	import {
		providerSelectItem
	} from '@/api/supplier';
  import {
    settlementExportRecordlist
  } from "@/api/order"
  import{
    getSearchDate,
    nextDay
  }from "@/utils/index"
  @Component({  
    name: '',
    components: {
      PageFooter,
      PickerDate,
    }
  })

  export default class ProductList extends Vue {
    private supplierNameKey = null
    private supplierList:any = []
    private filterTime = [getSearchDate(2,false,-29)[0],getSearchDate(2,false,0)[0]].join('/')
    private tablelist:any = []
    private tableloading = false
    private pageSize = 20
    private pageNo = 1
    private total = 0


    private mounted () {
      this.getSupplierList()
      this.gettablelist()
    }


    private changeCurrent(e){
      this.pageNo = e
      this.gettablelist()
    }
    private exportprimitive(row){
      window.open(row.FileUrlComplete)
    }
    private clearSearch(){
      this.supplierNameKey = null
      this.filterTime = [getSearchDate(2,false,-29)[0],getSearchDate(2,false,0)[0]].join('/')
      this.changeCurrent(1)
    }
    private async gettablelist(){
      try{
        this.tableloading = true
        let data:any ={
          ProviderId:this.supplierNameKey,
          Skip:(this.pageNo-1)*this.pageSize,
          Take:this.pageSize
        }
        if (this.filterTime) {
          var dt = this.filterTime.split('/');
          data.StartTime = dt[0];
          data.EndTime = nextDay(dt[1],1)
        }
        let res = await settlementExportRecordlist(data)
        if(res.IsSuccess){
          this.tablelist = res.Result.Results
          this.total = res.Result.Total
        }
      }finally{
        this.tableloading = false
      }
    }

    private async getSupplierList() {
			try {
				const res: any = await providerSelectItem({});
				this.supplierList = res.Result.map(v=>{
					return {
						value: v.Id,
						label: v.ProviderName
					}
				})
			}finally{
        //
      }
		}
  }
